<template>
	<div id="app">

		<router-view />

		<!-- Floating button start  -->
		<div class="fabWidget">
			<div class="fabTrigger">
				<div class="background"></div>
				<svg class="chat-bubble" width="80" height="80" viewBox="0 0 100 100">
				<g class="bubble">
					<path class="line line1" d="M 30.7873,85.113394 30.7873,46.556405 C 30.7873,41.101961
					36.826342,35.342 40.898074,35.342 H 59.113981 C 63.73287,35.342
					69.29995,40.103201 69.29995,46.784744" />
					<path class="line line2" d="M 13.461999,65.039335 H 58.028684 C
						63.483128,65.039335
						69.243089,59.000293 69.243089,54.928561 V 45.605853 C
						69.243089,40.986964 65.02087,35.419884 58.339327,35.419884" />
				</g>
				<circle class="circle circle1" r="1.9" cy="50.7" cx="42.5" />
				<circle class="circle circle2" cx="49.9" cy="50.7" r="1.9" />
				<circle class="circle circle3" r="1.9" cy="50.7" cx="57.3" />
				</svg>
			</div>
			<div class="fabList">
				<a class="fabButton whatsappBtn" href="javascript:void(0)" data-tooltip="WhatsApp">
					<svg clip-rule="evenodd" fill-rule="evenodd" height="512" image-rendering="optimizeQuality"
						shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 512 512" width="512"
						xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
						xmlns:xodm="http://www.corel.com/coreldraw/odm/2003" id="fi_4401461">
						<linearGradient id="id2" gradientUnits="userSpaceOnUse" x1="67.83" x2="474.19" y1="82.42" y2="389.98">
						<stop offset="0" stop-color="#39ae41"></stop>
						<stop offset="1" stop-color="#80c269"></stop>
						</linearGradient>
						<g id="Layer_x0020_1">
						<g id="_1639418321040">
							<path d="m256 0c141.39 0 256 114.61 256 256s-114.61 256-256 256-256-114.61-256-256 114.61-256 256-256z"
							fill="url(#id2)"></path>
							<g fill="#fff">
							<path
								d="m256 373.82c-20.85 0-41.37-5.55-59.32-16.04-2.89-1.69-6.37-2.14-9.6-1.26l-39.03 10.71 13.6-29.95c1.85-4.07 1.37-8.82-1.24-12.45-14.55-20.15-22.23-43.96-22.23-68.83 0-64.97 52.85-117.82 117.82-117.82s117.82 52.85 117.82 117.82-52.85 117.82-117.82 117.82zm0-260.58c-78.72 0-142.75 64.04-142.75 142.76 0 27.69 7.85 54.28 22.8 77.36l-21.69 47.77c-2 4.41-1.27 9.57 1.86 13.25 2.41 2.81 5.9 4.38 9.49 4.38 8.04 0 51.89-13.78 63.05-16.85 20.63 11.04 43.76 16.85 67.24 16.85 78.71 0 142.76-64.05 142.76-142.76 0-78.72-64.05-142.75-142.76-142.76z">
							</path>
							<path
								d="m290.08 272.69c-5.4 2.21-8.85 10.67-12.35 14.99-1.8 2.21-3.94 2.56-6.7 1.45-20.28-8.08-35.83-21.62-47.02-40.28-1.9-2.89-1.56-5.18.73-7.87 3.38-3.98 7.63-8.5 8.54-13.87 2.03-11.86-13.48-48.67-33.97-31.99-58.95 48.04 98.34 175.45 126.73 106.54 8.03-19.54-27-32.64-35.96-28.97z">
							</path>
							</g>
						</g>
						</g>
					</svg>
				</a>
				<a class="fabButton telegramBtn" href="javascript:void(0)" data-tooltip="Telegram">
					<svg fill="none" height="512" width="512" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><path d="M250 500c138.071 0 250-111.929 250-250S388.071 0 250 0 0 111.929 0 250s111.929 250 250 250z" fill="#34aadf"/><path d="M104.047 247.832s125-51.3 168.352-69.364c16.619-7.225 72.977-30.347 72.977-30.347s26.012-10.115 23.844 14.451c-.723 10.116-6.503 45.52-12.283 83.815-8.671 54.191-18.064 113.439-18.064 113.439s-1.445 16.619-13.728 19.509-32.515-10.115-36.127-13.006c-2.891-2.167-54.191-34.682-72.977-50.578-5.058-4.335-10.838-13.005.722-23.121 26.012-23.844 57.081-53.468 75.867-72.254 8.671-8.671 17.341-28.902-18.786-4.336-51.3 35.405-101.878 68.642-101.878 68.642s-11.561 7.225-33.237.722c-21.677-6.502-46.966-15.173-46.966-15.173s-17.34-10.838 12.284-22.399z" fill="#fff"/></svg>
				</a>
				<a class="fabButton" @click="openLiveChat()" data-tooltip="LiveChat">
					<svg width="130" height="130" viewBox="0 0 130 130" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="65" cy="65" r="65" fill="#37C174"/>
						<path d="M35 59.75C35 49.3947 43.3947 41 53.75 41H76.25C86.6053 41 95 49.3947 95 59.75V71C95 81.3553 86.6053 89.75 76.25 89.75H35V59.75Z" stroke="white" stroke-width="4"/>
						<circle cx="52.8125" cy="65.8125" r="2.8125" fill="white" stroke="white" stroke-width="2"/>
						<circle cx="64.9375" cy="65.8125" r="2.8125" fill="white" stroke="white" stroke-width="2"/>
						<circle cx="76.9375" cy="65.8125" r="2.8125" fill="white" stroke="white" stroke-width="2"/>
					</svg>
				</a>
			</div>
		</div>
		<!-- Whatsapp popup  -->
		<div class="whatsapp-pop">
				<div class="headsec d-flex align-items-center justify-content-between pb-4">
					<button class="btn back p-0 m-0 border-none">
						<img width="15" class="img-fluid" src="static/fxView/images/back.png">
					</button>
					<h3 class="m-0 f-20 darkcolor bold">WhatsApp</h3>
					<button class="btn close p-0 m-0"><img width="13" class="img-fluid" src="static/fxView/images/cross.png"></button>
				</div>
				<p class="f-15 mb-4">Scan the QR below to talk to our team from your mobile or <a class="themecolor" href="https://wa.me/35799397317" target="_blank">Whatsapp on your desktop</a>.</p>
	
			<div class="qr-wrap text-center">
				<img class="img-fluid" width="200" src="static/fxView/images/whatsapp-qrCode.svg">
			</div>
		</div>

		<!-- Telegram Popup -->
		<div class="telegram-pop">
			<div class="headsec d-flex align-items-center justify-content-between pb-4">
				<button class="btn back p-0 m-0 border-none">
					<img width="15" class="img-fluid" src="static/fxView/images/back.png">
				</button>
				<h3 class="m-0 f-20 darkcolor bold">Telegram</h3>
				<button class="btn close p-0 m-0"><img width="13" class="img-fluid" src="static/fxView/images/cross.png"></button>
			</div>
			<p class="f-15 mb-4">Scan the QR below to talk to our team from your mobile or <a class="themecolor" href="https://t.me/FxviewSupportBot" target="_blank">Telegram on your desktop</a>.</p>

			<div class="qr-wrap text-center">
				<img class="img-fluid" width="200" src="static/fxView/images/telegram-support-qr.svg">
			</div>
		</div>
		<!-- Floating Button end -->
	
	
	</div>
</template>

<script>
import * as types from './types'
import '../static/fxView/js/popper.min.js';
import '../static/fxView/js/bootstrap.min.js';
//import '../static/fxView/js/jquery.min.js';
import '../static/fxView/js/custom.js';
import { fxViewMixins } from '@/plugins/fxView'
import i18n from '@/plugins/lang/i18n';
import { mapActions } from 'vuex'
export default {
	name: 'App',
	mixins: [fxViewMixins],
	data() {
		return {
			languageChangeDetect: '',
			response_msg1: '',
			msg_type1: '',
			isWidgetExplicitlyOpened: false,
		}
	},
	created() {
		// console.log("1$store.getters.GET_USER.is_email_verified",this.$store.getters.GET_USER.first_deposit)
	},
	mounted: function () {
		const _that = this
		window.addEventListener("storage", (event) => {
			try {
				localStorage.removeItem('clientCountryJson');
				let countriesJson = localStorage.getItem("clientCountryJson")
				if (countriesJson) {
					_that.$store.commit(types.SET_COUNTRIES_FOR_CLIENT, JSON.parse(countriesJson))
				}
			} catch (e) { console.log('country-error----------------->', e); }
		});
		$(document).on('keypress', "input[type='text'],textarea", function (event) {
			var key = event.which || event.keyCode;
			if (parseInt(key) > 128) {

				_that.$toasted.show("Only English language is allowed", {
					position: "top-right",
					duration: 3000,
					type: 'info'
				});
				return false;
			}
		})

		// floating buttons start 
		var button = document.querySelector('.fabTrigger');
		var wrap = document.querySelector('.fabWidget');
		var overlay = document.querySelector('.fabOverlay');
		var buttonlist = document.querySelector('.fabList');
		var whatsapp = document.querySelector('.whatsappBtn');
		var whatsappPop = document.querySelector('.whatsapp-pop');
		var telegram = document.querySelector('.telegramBtn');
		var telegramPop = document.querySelector('.telegram-pop');
		var backbtns = document.querySelectorAll('.btn.back');
		var closebtns = document.querySelectorAll('.btn.close');


		button.onclick = function() {
			if(whatsappPop.classList.contains("show")){
				whatsappPop.classList.remove('show');
				wrap.classList.toggle('active');
			}else if(telegramPop.classList.contains("show")){
				telegramPop.classList.remove('show');
				wrap.classList.toggle('active');
			}else{
				button.classList.toggle('active');
				buttonlist.classList.toggle('active');
				wrap.classList.toggle('active');
				// overlay.classList.toggle('active');
			}
		}

		whatsapp.onclick = function() {
			whatsappPop.classList.toggle('show');
			buttonlist.classList.toggle('active');
		}
		telegram.onclick = function() {
			telegramPop.classList.toggle('show');
			buttonlist.classList.toggle('active');
		}

		for (var i = 0; i < backbtns.length; i++) {
			backbtns[i].onclick = function(){
				if(whatsappPop.classList.contains("show")){
				whatsappPop.classList.remove('show');
				buttonlist.classList.toggle('active');
				}else{
					telegramPop.classList.remove('show');
					buttonlist.classList.toggle('active');
				}
			}
		}

		for (var i = 0; i < closebtns.length; i++) {
			closebtns[i].onclick = function(){
				if(whatsappPop.classList.contains("show")){
				whatsappPop.classList.remove('show');
				wrap.classList.toggle('active');
				}else{
					telegramPop.classList.remove('show');
					wrap.classList.toggle('active');
				}
			}
		}
		// floating buttons end 

		// Initialize LiveChat widget script start
		// Initialize LiveChat widget
		this.initializeLiveChat();

		// Start watching for LiveChatWidget changes
		this.startWatchingLiveChatWidget();
	},
	beforeDestroy() {
		// Clear the watcher when the component is destroyed
		clearInterval(this.widgetWatcher);
	},
	methods: {
		openLiveChat() {
			// Open the LiveChat widget
			if (window.LiveChatWidget) {
				this.isWidgetExplicitlyOpened = true;
				window.LiveChatWidget.call("maximize"); // Open the chat widget
			} else {
				console.error("LiveChatWidget is not loaded yet.");
			}
		},
		initializeLiveChat() {
			window.__lc = window.__lc || {};
			window.__lc.license = 17433519;
			window.__lc.chat_between_groups = false;
			window.__lc.integration_name = "manual_channels";

			const self = this;

			(function (n, t, c) {
				function i(n) {
				return e._h ? e._h.apply(null, n) : e._q.push(n);
				}
				var e = {
				_q: [],
				_h: null,
				_v: "2.0",
				on: function () {
					i(["on", c.call(arguments)]);
				},
				once: function () {
					i(["once", c.call(arguments)]);
				},
				off: function () {
					i(["off", c.call(arguments)]);
				},
				get: function () {
					if (!e._h)
					throw new Error("[LiveChatWidget] You can't use getters before load.");
					return i(["get", c.call(arguments)]);
				},
				call: function () {
					i(["call", c.call(arguments)]);
				},
				init: function () {
					var n = t.createElement("script");
					n.async = !0;
					n.type = "text/javascript";
					n.src = "https://cdn.livechatinc.com/tracking.js";
					n.onload = () => {
					if (window.LiveChatWidget) {
						window.LiveChatWidget.call("hide");
						// self.setupWidgetListeners();
					}
					};
					t.head.appendChild(n);
				},
				};
				!n.__lc.asyncInit && e.init();
				n.LiveChatWidget = n.LiveChatWidget || e;
			})(window, document, [].slice);
		},
		startWatchingLiveChatWidget() {
			this.widgetWatcher = setInterval(() => {
				const currentState = window.LiveChatWidget && window.LiveChatWidget.get("state");
				if (currentState !== this.widgetState) {
					this.widgetState = currentState;
					if(this.widgetState.visibility=='minimized'){
						window.LiveChatWidget.call("hide");
					}
				}
			}, 500); // Check every 500ms
		}
	}
}
</script>

<style>
@import '../static/fxView/css/bootstrap.min.css';
@import '../static/fxView/css/apidoc_style.css';
@import '../static/fxView/css/stx-chart.css';
@import '../static/fxView/css/style.css';
@import '../static/fxView/css/responsive.css';
</style>


// WEBPACK FOOTER //
// src/App.vue